import React from 'react';
import NavBar from './components/Navbar';
import './App.css'
import Header from './components/Header';
import Product from './components/Product';

function App() {

  return (
    <div>
      <NavBar />
      <Header/>
      <Product/>
    </div>
  );
}

export default App;
